import { postNoticeOfInterest, postNoticeOfInterestGeneric } from '@/services/notice-of-interest.service'
import { ActionContext, Store } from 'vuex'
import { NoticeOfInterestGenericRequest, NoticeOfInterestRequest } from '@/types/notice-of-interest-page.types'
import { resolveToftaException } from '@/services/error-mapping.service'

export enum Properties {
  Loading = 'loading',
  Submitted = 'submitted',
  Exception = 'exception',
  ExceptionMessage = 'exceptionMessage',
  SubmitFormGeneric = 'submitFormGeneric',
  SubmitForm = 'submitForm',
  ResetState = 'resetState'
}

interface State {
  [Properties.Loading]: boolean;
  [Properties.Submitted]: boolean;
  [Properties.Exception]: boolean;
  [Properties.ExceptionMessage]: string | null;
}

export type VuexActionContext = ActionContext<State, {}>

export const NAMES_PACE = 'noticeOfInterestForm'
const namespace = (s: string): string => `${NAMES_PACE}/${s}`

export const getPostLoading = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Loading)]
export const getPostException = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Exception)]
export const getPostExceptionMessage = (store: Store<VuexActionContext>): string => store.getters[namespace(Properties.ExceptionMessage)]
export const getPostSubmitted = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Submitted)]
export const submitNoticeOfInterestGeneric = (store: Store<VuexActionContext>, request: NoticeOfInterestGenericRequest): Promise<void> => store.dispatch(namespace(Properties.SubmitFormGeneric), request)
export const submitNoticeOfInterest = (store: Store<VuexActionContext>, request: NoticeOfInterestRequest): Promise<void> => store.dispatch(namespace(Properties.SubmitForm), request)
export const resetState = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.ResetState))

const NoticeOfInterestPageStore = {
  namespaced: true,
  state: {
    [Properties.Loading]: false,
    [Properties.Submitted]: false,
    [Properties.Exception]: false,
    [Properties.ExceptionMessage]: null
  },
  getters: {
    [Properties.Loading]: (state: State) => state[Properties.Loading],
    [Properties.Submitted]: (state: State) => state[Properties.Submitted],
    [Properties.Exception]: (state: State) => state[Properties.Exception],
    [Properties.ExceptionMessage]: (state: State) => state[Properties.ExceptionMessage]
  },
  mutations: {
    [Properties.Loading]: (state: State, loading: boolean) => {
      state[Properties.Loading] = loading
    },
    [Properties.Submitted]: (state: State, exception: boolean) => {
      state[Properties.Submitted] = exception
    },
    [Properties.Exception]: (state: State, exception: boolean) => {
      state[Properties.Exception] = exception
    },
    [Properties.ExceptionMessage]: (state: State, exceptionMessage: string) => {
      state[Properties.ExceptionMessage] = exceptionMessage
    }
  },
  actions: {
    [Properties.SubmitFormGeneric]: async ({ commit }: ActionContext<State, {}>, request: NoticeOfInterestGenericRequest): Promise<void> => {
      try {
        commit(Properties.Loading, true)
        await postNoticeOfInterestGeneric(request)
        commit(Properties.Submitted, true)
      } catch (err) {
        commit(Properties.ExceptionMessage, resolveToftaException(err))
        commit(Properties.Exception, true)
      } finally {
        commit(Properties.Loading, false)
      }
    },
    [Properties.SubmitForm]: async ({ commit }: ActionContext<State, {}>, request: NoticeOfInterestRequest): Promise<void> => {
      try {
        commit(Properties.Loading, true)
        await postNoticeOfInterest(request)
        commit(Properties.Submitted, true)
      } catch (err) {
        commit(Properties.ExceptionMessage, resolveToftaException(err))
        commit(Properties.Exception, true)
      } finally {
        commit(Properties.Loading, false)
      }
    },
    [Properties.ResetState]: async ({ commit }: ActionContext<State, {}>): Promise<void> => {
      commit(Properties.Loading, false)
      commit(Properties.Submitted, false)
      commit(Properties.Exception, false)
      commit(Properties.ExceptionMessage, null)
    }
  }
}

export default NoticeOfInterestPageStore
